// This should match the $breakpoint-nav-hamburger scss variable, in _config.scss
const breakpoint_navigation = 650;



// Get the open/close nav buttons, and the main nav container.
const open_nav_button = document.getElementById('open-mobile-nav');
const close_nav_button = document.getElementById('close-mobile-nav');



// Add a click listener to the hamburger button that open the mobile navigation.
if( open_nav_button ){
    open_nav_button.addEventListener( 'click', function(){
        taoti_open_nav();
    });
}

// Likewise, add a click listener to the close button that closes the mobile navigation.
if( close_nav_button ){
    close_nav_button.addEventListener( 'click', function(){
        taoti_close_nav();
    });
}



// Open the nav menu
// Add a class to the root <html> element, which will trigger the CSS styles for an open navigation menu.
function taoti_open_nav(){
	document.documentElement.classList.add('nav-is-open');
}

// Close the nav menu
// Removes the class from the <html> element.
function taoti_close_nav(){
	document.documentElement.classList.remove('nav-is-open');
}



// Watch for the window size to change, and remove the open nav class when the CSS breakpoint is reached.
function taoti_check_window_width(){

    if( window.innerWidth > breakpoint_navigation ){
			taoti_close_nav();
    }

}
window.addEventListener( "resize", taoti_check_window_width, false);
